import { memo, useCallback, useEffect, useMemo, useRef, useState } from "react"
import styles from './newBTemplateTest.module.scss'
import BTemplateContent from "./BTemplateContent"
import { jointImg, getCookieItem, isNew } from "@/lib/commonService";
import GlassColor, {
    ColorData,
    getColorData,
    translateIColorDataToIColorItem,
} from "../../ColorSelect/GlassColor";
import { getEnv } from "@/src/utils/configUtils";
import { FmButton, FmIcon, FmImage, FmLink } from "@/ui-component";
import FmTag from "@/ui-component/basic/FmTag";
import { useCommonContext, useFilterConditionContext, usePageInfoContext, useRateContext } from "@/src/provider";
import classnames from "classnames";
import ColorSelect from "../../ColorSelect";
import acquisition from "../../LoadAnalysis/analysis/DataAcquisition";
import { AddFlow, flowSpcice, gaCommonEvent, getDiscountText, productClick } from "@/src/utils";
import { addProductsSkuClickEvent } from "@/src/models/emailData";
import FilterModalNew from "../../FilterModalNew";
import { useFetchProducts } from "@/src/provider/Products/hooks";
import SizeGuiderButton from "../../SizeGuider/SizeGuiderButton";
import { t } from "i18next";
import { filterByLensTotalWidth } from "@/src/utils/lens/productdetail";
import { tryOn } from "@/store";
import {
    addProductsToDetailEvent,
} from "@/src/models/emailData";
import { CURRENCY_COOKIE_NAME, zodiacPageIds } from "@/config/constConf";
import { ProductInfo } from "@/src/app/specsubs/[id]/type";
import { usePathname } from "next/navigation";
import CountDownClient from "../../CountDown/CountDownCmsClient";
interface NewBTemplateProps {   
    data: any;
    filterViews:(a: boolean) => void; // 添加 filterViews 的类型定义
}

const BTemplateIcon:any = { 
    shaixuan: "icon-shaixuan",
};

const NewBTemplateTest: React.FC<NewBTemplateProps> = ({ data,filterViews }) => {
    const [currentIndex, setCurrentIndex] = useState(1);
    const [isExpanded, setIsExpanded] = useState(false); // 新增状态，跟踪文本是否展开
    const {
        products_color_info,
        products_name_attribute,
        products_model,
        products_sex,
        products_description,
        products_video_list,
        products_model_show,
        products_id
    } = data;
    const colorData = getColorData(products_color_info);
    const touchStarRef = useRef({ x: 0, y: 0 });
    const activeColorObj = useMemo(() => colorData[0], [colorData]);
    const [activeColor, setActiveColor] = useState<ColorData>(activeColorObj);
    const { host, site } = useCommonContext();
    const [clickButtonToOpenTryOn] = tryOn.useTryonStore((state) => [
        state.clickButtonToOpenTryOn,
    ]);
    const [firstEnter, setFirstEnter] = useState(true);
    const pathname = usePathname() ?? "";
     const [isPlaying, setIsPlaying] = useState(true)
    const discountText = parseInt(getDiscountText(host, activeColor.salePer, t).replace(/[^0-9]/g, "")); ;// 折扣

    /*
     * 图片列表
     */
    const contentList = useMemo(() => {
        const imgShowche = jointImg({
            productId: products_id,
            size: "middle",
            imgTotal: 1,
            name: activeColor.img,
        });
        const imgShow = jointImg({
            productId: products_id,
            size: "middle",
            imgTotal: 2,
            name: activeColor.img,
        });
        const imgShowzhuan = jointImg({
            productId: products_id,
            size: "middle",
            imgTotal: 3,
            name: activeColor.img,
        });
        let modelImgList = products_model_show[0]
            ? `${getEnv("IMG_HOST")}/p/${products_model_show[0].products_id
            }/${products_model_show[0].sort}-${products_model_show[0].image}`
            : "";

        // 尺寸图
        // 正面
        const dimensionY = {
            type: "Y",
            src: imgShow,
            dimensions_bridge: data.dimensions_bridge,
            dimensions_diagonal: data.dimensions_diagonal,
            dimensions_height: data.dimensions_height,
            dimensions_lens: data.dimensions_lens,
            dimensions_temple: data.dimensions_temple,
            dimensions_total_width: data.dimensions_total_width,
        };
        // 侧面
        const dimensionX = {
            type: "X",
            src: imgShowche,
            dimensions_bridge: data.dimensions_bridge,
            dimensions_diagonal: data.dimensions_diagonal,
            dimensions_height: data.dimensions_height,
            dimensions_lens: data.dimensions_lens,
            dimensions_temple: data.dimensions_temple,
            dimensions_total_width: data.dimensions_total_width,
        };
        /*
         * 视频
         */

        const list = [
            ...products_video_list,
            imgShow,
            imgShowche,
            imgShowzhuan,
            modelImgList,
            dimensionY,
            dimensionX,
        ];
        return list.filter((item) => !!item);
    }, [
        activeColor,
        data.dimensions_bridge,
        data.dimensions_diagonal,
        data.dimensions_height,
        data.dimensions_lens,
        data.dimensions_temple,
        data.dimensions_total_width,
        products_id,
        products_model_show,
        products_video_list,
    ]);

    // 专题页页面信息
    const [
        show_Price,
        is_personalize,
        layout_type,
        singleCol,
        isPackage,
        pageId,
    ] = usePageInfoContext((state) => [
        state.showPrice,
        state.is_personalize,
        state.layout_type,
        state.isSingleCol,
        state.isPackage,
        state.page_id,
    ]);
    const is_sku = usePageInfoContext((state) => state.is_sku);
    const [selected, setSelected] = useState<number>(activeColorObj?.id);
    const [isBluePage, setIsBluePage] = useState(false);
    const [isDrivePage, setIsDrivePage] = useState(false);
    const [filterItem, filterSubItem] = useFilterConditionContext((state) => [
        state.filterItem,
        state.filterSubItem,
    ]);
    const [isShowFilterModal, setIsShowFilterModal] = useState<boolean>(false);
    const [isViewDetailsModal, setIsShowViewDetailsModal] = useState<boolean>(false);
    const [openViewDetailsOn,changeDetailsID] = usePageInfoContext((state) =>  [state.openViewDetailsOn, state.changeDetailsID]);
    /*
     * 颜色选择
     */
    const colorChange = useCallback(
        (value: number, cb?: Function) => {
            if (selected === value) {
                return;
            }
            const activeColorObj = colorData.find(
                (item: { id: number }) => item.id === value,
            );
            const swiperIndex = contentList.filter((item:any)=> typeof item =='object' && item.video_url)
            setSelected(value);
            if (activeColorObj) {
                setActiveColor(activeColorObj);
                typeof cb === "function" && cb(activeColorObj.id);
                //有问题，要处理  
                if(swiperIndex.length > 0) {
                    setCurrentIndex(2);
                } else {
                    setCurrentIndex(1);
                }

            }

            setTimeout(() => {
                if (products_id && activeColorObj?.id) {
                    acquisition.clickProduct(
                        "clickProduct",
                        `${products_id}-${activeColorObj.id}`,
                    );
                    gaCommonEvent("new_specsubs_click_product");
                }
                addProductsSkuClickEvent({
                    colorId: activeColorObj?.id,
                    price: activeColorObj?.countPrice,
                    filterItem,
                    filterSubItem,
                });
            });
        },
        [colorData, products_id, filterItem, filterSubItem, selected],
    );
    const getPrice = useRateContext((state) => state.getPrice);
    /*
    *   轮播图切换     
    */
    const updateCurrentIndex = useCallback((index: number) => {
        setCurrentIndex(index + 1);
    }, []);
    // 阻止横向滑动的冒泡 
    const handleTouchMove = useCallback(
        (e: React.TouchEvent<HTMLDivElement>) => {
            if (e.touches.length > 0) {
                const deltaX = Math.abs(
                    e.touches[0].pageX - touchStarRef.current.x,
                );
                const deltaY = Math.abs(
                    e.touches[0].pageY - touchStarRef.current.y,
                );
                if (deltaX > deltaY) e.stopPropagation();
            }
        },
        [],
    );
    // 阻止横向滑动的冒泡
    const handleTouchStart = useCallback(
        (e: React.TouchEvent<HTMLDivElement>) => {
            if (e.touches.length > 0) {
                touchStarRef.current = {
                    x: e.touches[0].pageX,
                    y: e.touches[0].pageY,
                };
            }
        },
        [],
    );
    // 判断是否属于特定类型的眼镜页面
    const isSpecificGlassesPage = useCallback(
        (pageNames: string[]) => {
            return pageNames.some((pageName) => pathname.includes(pageName));
        },
        [pathname],
    );
    // 判断是否是蓝光眼镜
    const isBluePageList = useCallback(() => {
        return isSpecificGlassesPage(["computer-glasses.html"]);
    }, [isSpecificGlassesPage]);

    // 判断是否是驾驶眼镜
    const isDrivePageList = useCallback(() => {
        return isSpecificGlassesPage([
            "driving-glasses-men.html",
            "driving-glasses-women.html",
        ]);
    }, [isSpecificGlassesPage]);
    useEffect(() => {
        if (activeColorObj?.is_favorite && firstEnter) {
            setFirstEnter(false);
        }
        setIsDrivePage(isDrivePageList());
        setIsBluePage(isBluePageList());
    }, [
        activeColorObj?.is_favorite,
        data,
        firstEnter,
        isBluePageList,
        isDrivePageList,
    ]);

    // 处理"see more"点击事件
    const handleSeeMoreClick = useCallback(() => {
        setIsExpanded(!isExpanded);
    }, [isExpanded]);
    // 筛选modal显示
    const toggleFilterModal = () => {
        setIsShowFilterModal(!isShowFilterModal);
    };
    const fetchProductsRes = useFetchProducts();
    const refresh = useCallback(() => {
         filterViews(true)
        // backTop();
        // 给url加上筛选后的条件
        fetchProductsRes("filter", { page: 1 });
    }, [fetchProductsRes, filterViews]);
    //打开弹窗
    const openFilterModal = useCallback(() => {
        gaCommonEvent("b_product_view");
        changeDetailsID(products_id);
        openViewDetailsOn();
    }, []);

    const widthText = useMemo(() => {
        const width = filterByLensTotalWidth(data.dimensions_total_width);
        return width === "S"
            ? t("productDetail:SMALL")
            : width === "M"
                ? t("productDetail:MEDIUM")
                : t("productDetail:LARGE");
    }, [data.dimensions_total_width, t]);
    const handleTryOnClick = useCallback(() => {
        clickButtonToOpenTryOn(activeColor.id, data);
    }, [activeColor.id, clickButtonToOpenTryOn, data]);
    const handleClickPro = useCallback(() => {
        if (products_id && activeColor.id) {
            acquisition.clickProduct(
                "clickProduct",
                `${products_id}-${activeColor.id}`,
            );
        }
        addProductsToDetailEvent({
            colorId: activeColor.id,
            price: activeColor.countPrice,
            filterItem,
            filterSubItem,
        });
        AddFlow.ProductClick(products_id);
        flowSpcice.ProductClick(products_id);
        productClick({
            currency: getCookieItem(CURRENCY_COOKIE_NAME),
            value: activeColor?.price,
            items: [
                {
                    id: products_id,
                    name: data.products_model,
                    item_id: products_id,
                    item_name: data.products_model,
                },
            ],
        });

        // 重构项目埋点，跟老项目gaCommonEvent('old_specsubs_click_product');对应
        gaCommonEvent("new_specsubs_click_product");
    }, [
        activeColor?.countPrice,
        activeColor?.id,
        activeColor?.price,
        products_id,
        data.products_model,
        filterItem,
        filterSubItem,
    ]);
    const isHot = useMemo(
        () => data.products_months_ordered >= 50,
        [data.products_months_ordered],
    );
    const getProDetailHref = useCallback(
        (data: ProductInfo) => {
            const { products_id, master_categories_id } = data;
            const packageUrl = isPackage ? `&is_package=${pageId}` : "";
            const blueGlassUrl = isBluePage ? "&buleglass=1" : "";
            const driveGlassUrl = isDrivePage ? "&driveglass=1" : "";

            const pageParam = zodiacPageIds.includes(pageId)
                ? `&page=${pageId}`
                : "";
            const sublink =
                pageId && layout_type === 0 ? `&sublink=${pageId}` : "";
            const isPersonalize = is_personalize ? "&is_personalize=true" : "";

            const finalUrl =
                `/productDetail/${products_id}?color=${activeColor.id}${sublink}` +
                `&master_categories_id=${master_categories_id}` +
                `${blueGlassUrl}${driveGlassUrl}${packageUrl}` +
                `${pageParam}${isPersonalize}`;
            return finalUrl;
        },
        [
            activeColor.id,
            isBluePage,
            isDrivePage,
            isPackage,
            is_personalize,
            layout_type,
            pageId,
        ],
    );
    const isNewProduct = useMemo(
        () =>
            isNew(
                data.products_date_added_stortime ?? data.products_date_added,
            ),
        [data.products_date_added, data.products_date_added_stortime],
    );
    const _onSale = useMemo(
        () => activeColor?.onSale && show_Price,
        [activeColor, show_Price],
    );

    const showTag = useMemo(() => {
        if (isHot) {
            return <FmTag backgroundColor="#E6A858">HOT</FmTag>
        }
        if (isNewProduct) {
            return <FmTag backgroundColor="#58B9E6">{t("common:NEW")}</FmTag>;
        }
        // if (_onSale) {
        //     return activeColor.salePer < 0 ? (
        //         <FmTag />
        //     ) : (
        //         <FmTag backgroundColor="#EE5454">{discountText}</FmTag>
        //     );
        // }
    }, [isHot, isNewProduct, _onSale, activeColor.salePer, host, singleCol, t])
    const titleImg = useMemo(() => {
        //取出里面的所有图片--过滤掉对象
        const list = contentList.filter((item: any) => typeof item !== 'object')
        //轮询list数据，判断链接参数是否含有/middle-2，让后返回
        const titleImg = list.find((item: any) => item?.includes('/middle-2'))
        return titleImg
    }, [contentList]);
      const  stopPropagation = (e: React.TouchEvent) => {
        return e.stopPropagation();
    }

    return (
        <div className={styles['product']}>
            <div
                className={styles['show']}
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
            >
                {/* 轮播图 */}
                <BTemplateContent
                    activeIndex={currentIndex -  1 }
                    contentList={contentList}
                    updateCurrentIndex={updateCurrentIndex}
                    isPlaying={isPlaying} // 新增props
                />
                {/* talla */}
                <div className={styles['size-info']}>
                    {currentIndex === contentList.length - 1 || currentIndex === contentList.length ? (
                        <div className={styles['size-text']}>
                            <span>{t("productDetail:Size")}:</span>
                            <span>{widthText}</span>
                            <SizeGuiderButton onPlayStateChange={setIsPlaying}>{t("specialSub:SizeGuide")}</SizeGuiderButton>
                        </div>
                    ) : (
                        <div></div>
                    )}      
                </div>
            </div>
            {/* 筛选 */}
            <div  onTouchMove={(e) => {
                stopPropagation(e)
            }}
            >
            <FilterModalNew
                open={isShowFilterModal}
                onClose={toggleFilterModal}
                refresh={refresh}
            />
         
            </div>
            {/* probar--暂时关闭 */}
            {/* <FmButton className={styles['tryon-button']} onClick={handleTryOnClick}>
                {t("common:TRYON")}
            </FmButton> */}
            {/* 打开筛选模态框 */}
            <div className={styles['filter']} >
                <div className={styles['filter-Button']} onClick={() => { toggleFilterModal() }}>
                    <FmIcon
                        icon={BTemplateIcon.shaixuan}
                        className={styles["shaixuan"]}
                    />
                    <span>Filter</span>
                </div>
            </div>
            <div className={styles['info']}>


                {products_description?.length > 0 && (
                    <div className={styles['text']}>
                        <p className={isExpanded ? styles['expanded'] : ''}>
                            {products_description}
                        </p>
                        <span onClick={handleSeeMoreClick}>
                            {isExpanded ? 'see less' : 'see more'}
                        </span>
                    </div>
                )}

                <div className={styles['card']}>
                    {_onSale && activeColor.salePer > 0 && <div className={styles['card-top']}>
                        <span className={styles['flash']}>
                            <FmImage
                                image={"https://df5apg8r0m634.cloudfront.net/images/1215b4f6636925f1c544be32ba35431a.png"}
                                width={9}
                                height={12}
                            />
                            <span>Flash Sale</span>
                        </span>
                        <span className={styles['end-time']}>
                            {/* <CountDown
                                lastTime={Math.floor(Date.now() / 1000) + 864000}
                                startTime={Math.floor(Date.now() / 1000) - 86400}
                            /> */}
                            <CountDownClient
                                endText={t("Ends in")}
                                lastTime={activeColor.end}
                                startTime={activeColor.star}
                                timeFormart= {["d", "h", "m", "s"]}
                                styleLint={{ backgroundColor: "#E098AD",color: "#fff"}}
                            />
                        </span>
                    </div>
                    }
                    <div className={styles['card-bottom']}>
                        <div
                            className={styles['card-bottom-left']}
                        >
                            <FmLink
                                onClickCapture={handleClickPro}
                                href={getProDetailHref(data)}
                                target={"_blank"}
                                style={{ color: "unset", display: "block" }}
                            >
                                {_onSale && activeColor.salePer > 0 && <div className={styles['discount-container']}>
                                    <div className={styles['discount-content']}>
                                        <span className={styles['percent']}>
                                            {discountText}</span>
                                        <div className={styles['percent-text']}>
                                            <span>%</span>
                                            <span>OFF</span>
                                        </div>
                                    </div>
                                </div>}
                                <FmImage
                                    image={titleImg}
                                    width={99}
                                    height={44}
                                    style={{  mixBlendMode: 'multiply' }}
                                />
                            </FmLink>
                        </div>
                        <div className={styles['card-bottom-right']}>
                            <FmLink
                                onClickCapture={handleClickPro}
                                href={getProDetailHref(data)}
                                target={"_blank"}
                                style={{ color: "unset"}}
                            >
                                <div className={styles['model']}>
                                    <div className={styles['model-name']}>{products_name_attribute || products_model}</div>
                                    {/* 是否是儿童 */}
                                    {products_sex === 3 && (
                                        <FmImage
                                            image={
                                                "/__firmoo/static/icon/phone/icon_kids.png"
                                            }
                                            className={styles["product-state-icon"]}
                                            style={{
                                                margin: "0.1rem",
                                                width: "0.55rem",
                                            }}
                                            alt="icon_kids"
                                        />
                                    )}
                                    <div className={styles['model-price']}>
                                        {showTag}

                                    </div>
                                </div>
                            </FmLink>
                            <div className={styles['colors']}>
                                {/* 颜色选择 */}
                                {!is_sku && (
                                    <ColorSelect
                                        onChange={(selected: number) => colorChange(selected)}
                                        selected={selected}
                                        className={styles["color-select"]}
                                    >
                                        {translateIColorDataToIColorItem(colorData).map(
                                            (item, index) => (
                                                <GlassColor
                                                    key={index}
                                                    color_id={item.color_id}
                                                    color_name={item.color_name}
                                                />
                                            ),
                                        )}
                                    </ColorSelect>
                                )}
                            </div>
                            <div className={styles['price-Details']}>
                                <FmLink
                                    onClickCapture={handleClickPro}
                                    href={getProDetailHref(data)}
                                    target={"_blank"}
                                    style={{ color: "unset"}}
                                >
                                    <div className={styles['price']}>
                                        <span >
                                            {/* 价格 */}
                                            {show_Price && (
                                                <p
                                                    className={classnames(styles["p_w"], {
                                                        ["hidden"]: !show_Price && activeColor,
                                                    })}
                                                >                                                       {activeColor.onSale && (
                                                        <s
                                                            dangerouslySetInnerHTML={{
                                                                __html: getPrice(activeColor.price),
                                                            }}
                                                        ></s>
                                                    )}
                                                    {getPrice(activeColor.countPrice)}
                                                </p>
                                            )}
                                        </span>
                                    </div>
                                </FmLink>
                                <div className={styles['Details']}>
                                        <FmButton onClick={openFilterModal} size="medium" className={styles['Details-btn']} >
                                            {/* View Details */}
                                            {t("productDetail:SelectLenses")}   
                                        </FmButton>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default memo(NewBTemplateTest)

